/**
 * Relational FK columns on `line_items`. A "component template" is a relation-free
 * line item — every one of these is forced to null before saving so the row carries
 * no project/area/material/finish/template association.
 */
export const TEMPLATE_RELATION_FIELDS = [
  'area_id',
  'template_id',
  'frame_template_id',
  'box_material_id',
  'door_material_id',
  // present in CreateLineItemSchema but not (yet) columns on the line_items entity — nulled defensively
  'drawer_front_material_id',
  'drawer_box_material_id',
  'back_material_id',
  'shelf_material_id',
  'edgeband_material_id',
  'finish_id',
  'construction_method_id',
  'on_toe_kick_run_id',
] as const;

/**
 * Return a copy of a create-line-item payload with all relational FK columns nulled
 * and `is_template` set to true, so it persists as a standalone template (no
 * relations) in the `line_items` table. The `is_template` flag is how template rows
 * are told apart from regular line items. Non-relational columns (dimensions, codes,
 * *_config JSON, spec strings) are preserved.
 */
export function toTemplatePayload<T extends Record<string, any>>(payload: T): T {
  const out: any = { ...payload };
  for (const field of TEMPLATE_RELATION_FIELDS) {
    out[field] = null;
  }
  out.is_template = true;
  return out as T;
}
